<template>
  <div id="confirmacao-sucesso">
    <div class="topics">
      <span class="bold-title-big"> 1- Recomendações </span>
      <span class="text-md-regular"> {{recomendacao}}</span>
    </div>
    <div class="topics">
      <span class="bold-title-big"> 2- Salve na sua agenda </span>
      <span class="text-md-regular"> {{textoSalvarNaAgenda}}</span>
      <el-button @click="salvarAgenda" :style="`background: ${corBotaoPrincipal}`" class="btn-md">
        <inline-svg style="height: 13px" :fill="corTextoBotaoPrincipal" :src="require('@/assets/icons/Icon_schedule_calendar.svg')"/>
        <span class="text-principal" :style="`color: ${corTextoBotaoPrincipal}`">CRIAR ALARME NA AGENDA</span>
      </el-button>
      <span class="text-regular-sm">Você também pode baixar o <el-button @click="icsDownload()" style="padding: 0;" type="text"> <span class="link">arquivo ICS</span></el-button>  e adicionar o evento manualmente.</span>
    </div>
    <div class="topics">
      <span class="bold-title-big"> 3 - Instale o aplicativo </span>
      <span class="text-md-regular"> {{textoBaixarAplicativo}}</span>
      <div class="imgs">
        <div class="cursor-pointer" @click="goToAppStore">
          <img class="img-app" :src="require('@/assets/img/img_download_ios.png')">
        </div>
        <div class="cursor-pointer" @click="goToGooglePlay">
          <img class="img-app" :src="require('@/assets/img/img_download_android.png')">
        </div>
      </div>
      <span class="text-regular-sm">Disponível gratuitamente para iPhone e Android.</span>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import inlineSvg from 'vue-inline-svg'

export default {
  data () {
    return {
      googleCalendarLink: null
    }
  },
  computed: {
    ...mapState('Func53', ['agendamento', 'idAgenda', 'local', 'paciente', 'sucessoAgendamento']),
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapGetters('SetupApp', ['aplicacao']),
    recomendacao () {
      return this.funcionalidade.parametros.textos.textoRecomendacao
    },
    textoSalvarNaAgenda () {
      return this.funcionalidade.parametros.textos.textoCriarAlarme
    },
    corBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corBotaoPrincipal
    },
    corTextoBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corTextoBotaoPrincipal
    },
    textoBaixarAplicativo () {
      return this.funcionalidade.parametros.textos.textoBaixarAplicativo
    }
  },
  methods: {
    salvarAgenda () {
      const event = {
        title: `Consulta agendada com ${this.agendamento.nome} - ${this.agendamento.especialidade.descricao}`,
        startTime: new Date(this.sucessoAgendamento.agenda.dataHora),
        endTime: new Date(this.sucessoAgendamento.agenda.dataHora),
        location: Number(this.idAgenda) === 1 ? this.agendamento.localAtendimento.descricao + ', ' + this.local.endereco.endereco + ', ' + this.local.endereco.cidade + ', ' + this.local.endereco.bairro + ', ' + this.local.endereco.numero : ''
      }

      this.googleCalendarLink = `http://www.google.com/calendar/event?action=TEMPLATE&text=${event.title || ''}
      &dates=${this.formatDate(event.startTime)}/${this.formatDate(event.endTime)}&details=${event.details || ''}
      &location=${event.location || ''}`

      window.open(this.googleCalendarLink, '_blank')
    },
    goToAppStore () {
      window.open(`${this.aplicacao.textos.urlAppStore}`)
    },
    goToGooglePlay () {
      window.open(`${this.aplicacao.textos.urlGooglePlay}`)
    },
    formatDate (date) {
      const day = date.getUTCDate()
      const monthIndex = date.getUTCMonth()
      const year = date.getUTCFullYear()

      const hour = date.getUTCHours()
      const minutes = date.getUTCMinutes()

      let formattedDate
      if (hour === 0 && minutes === 0) {
        formattedDate = ('' + year) + this.pushZero(monthIndex + 1) + this.pushZero(day)
      } else {
        formattedDate = ('' + year) + this.pushZero(monthIndex + 1) + this.pushZero(day) + 'T' + this.pushZero(hour) + this.pushZero(minutes) + '00Z'
      }
      return formattedDate
    },
    pushZero (num) {
      if (num < 10) return '0' + num
      return num
    },
    icsDownload () {
      this.$ics.addEvent('pt-br', 'Agendamento de consulta', `Consulta agendada com ${this.agendamento.nome} - ${this.agendamento.especialidade.descricao}`,
        Number(this.idAgenda) === 1 ? this.agendamento.localAtendimento.descricao + ', ' + this.local.endereco.endereco + ', ' + this.local.endereco.cidade + ', ' + this.local.endereco.bairro + ', ' + this.local.endereco.numero : '',
        new Date(this.sucessoAgendamento.agenda.dataHora),
        new Date(this.sucessoAgendamento.agenda.dataHora))
      this.$ics.download('consulta')
    }
  },
  components: {
    inlineSvg
  },
  created () {
  }
}
</script>
